import { render, staticRenderFns } from "./TabelaValidacoesSerigy.vue?vue&type=template&id=4750b1f6&scoped=true"
import script from "./TabelaValidacoesSerigy.vue?vue&type=script&lang=ts"
export * from "./TabelaValidacoesSerigy.vue?vue&type=script&lang=ts"
import style0 from "./TabelaValidacoesSerigy.vue?vue&type=style&index=0&id=4750b1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4750b1f6",
  null
  
)

export default component.exports